import { render } from "./form-profile.vue?vue&type=template&id=73b203ac"
import script from "./form-profile.vue?vue&type=script&lang=js"
export * from "./form-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__